import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function NavBar({ config }) {
  const location = useLocation();

  if (!config) return null;

  const visibleTabs = config.tabs.filter(tab => tab.visible);

  // 관리자 페이지에서는 NavBar 표시하지 않음
  if (location.pathname === '/admin') {
    return null;
  }

  return (
    <nav className='sticky top-0 z-50 bg-white shadow-sm border-b'>
      <div className='max-w-4xl mx-auto px-4 py-4 text-center flex flex-col items-center gap-3'>
        <h1 className='text-xl font-bold text-blue-700'>{config.siteTitle}</h1>
        <div className='flex flex-wrap justify-center gap-3 text-sm font-medium'>
          {visibleTabs.map((tab) => (
            <Link
              key={tab.path}
              to={tab.path}
              className={`px-4 py-1.5 rounded-full transition ${
                location.pathname === tab.path
                  ? 'bg-blue-600 text-white'
                  : 'text-gray-700 hover:bg-blue-100'
              }`}
            >
              {tab.label}
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
}

export default NavBar;
